import { Button } from "../ui";
import { Github, LinkedinIcon, Mail } from "lucide-react";

const socialLinks = [
  {
    href: "https://www.linkedin.com/in/nadjem-eddine-aissa-a68bb21b0/",
    icon: LinkedinIcon,
    label: "LinkedIn",
  },
  {
    href: "https://github.com/Nadjem-47",
    icon: Github,
    label: "GitHub",
  },
  {
    href: "mailto:nadgmo@gmail.com",
    icon: Mail,
    label: "Email",
  },
];

export const SocialIcons = () => {
  return (
    <div className="flex items-center gap-8 mb-8">
      {socialLinks.map(({ href, icon: Icon, label }) => (
        <Button
          key={label}
          variant="ghost"
          size="icon"
          className="hover:bg-slate-100 dark:hover:bg-slate-800"
          onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
        >
          <Icon className="h-14 w-14" />
          <span className="sr-only">{label}</span>
        </Button>
      ))}
    </div>
  );
}; 